import { render, staticRenderFns } from "./DetailCombo.vue?vue&type=template&id=4bffb9a0&scoped=true"
import script from "./DetailCombo.vue?vue&type=script&lang=js"
export * from "./DetailCombo.vue?vue&type=script&lang=js"
import style0 from "./DetailCombo.vue?vue&type=style&index=0&id=4bffb9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bffb9a0",
  null
  
)

export default component.exports